import { useCallback } from "react";

import { placeBid } from "../lib/auctions";

import { AUCTIONS } from "../utils";

import { Auction, Product } from "../types";

export const useOnBuyWithCard = (
  setConfirmingBid: (boolean) => void,
  customerId: number,
  setPlacingBid: (boolean) => void
) => {
  const onBuyWithCard = useCallback(
    (auction: Auction, variant: Product, bidAmount: number) => {
      let abortController = new AbortController();
      (async () => {
        setConfirmingBid(true);

        let invoice_url = "";
        switch (auction.kind) {
          case "Ascending": {
            await placeBid({
              abortController,
              auctionId: auction.id,
              productId: variant.external_id,
              customerId,
              action: auction.kind,
              params: {
                price: bidAmount,
              },
            });
            break;
          }
          case "GDAContinuous": {
            invoice_url = await placeBid({
              abortController,
              auctionId: auction.id,
              productId: variant.external_id,
              customerId,
              action: AUCTIONS[auction.kind].ACTION,
              params: {
                quantity: bidAmount,
              },
            });
            break;
          }
          case "GDADiscrete": {
            invoice_url = await placeBid({
              abortController,
              auctionId: auction.id,
              productId: variant.external_id,
              customerId,
              action: AUCTIONS[auction.kind].ACTION,
              params: {
                quantity: bidAmount,
              },
            });
            break;
          }
          default: {
            return;
          }
        }
        setConfirmingBid(true);
        setPlacingBid(false);
        if (invoice_url !== "") {
          let delay = setTimeout(() => {
            window.open(invoice_url, "_blank");
            setPlacingBid(false);
          }, 500);
          return () => clearInterval(delay);
        }
      })();

      return () => abortController?.abort();
    },
    [customerId]
  );

  return { onBuyWithCard };
};
